export enum OrderStatus {
  Created = 'created',
  Accepted = 'accepted',
  Canceled = 'canceled',
  Ready = 'ready',
  Delivered = 'delivered',
  InDelivery = 'in-delivery',
  UnknownResult = 'unknown-result',
}
